<template>
    <div class="brand-box">
        <div class="head-box"><navBar></navBar></div>
        <div class="content">
            <div class="banner-box" v-img="{ form: form.bannerObj, key: 'img' }" :style="'background-image: url(' + form.bannerObj.img + ')'">
                <div class="text-content wow fadeInUp" @click.stop>
                    <p class="name pingFang-Bold font50" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                    <p class="tip-text font26" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</p>
                </div>
            </div>

            <!-- 海量开店用户聚集s -->
            <div class="number-show-box">
                <div class="container1">
                    <div class="wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                        <p class="tips font24" v-edit="{ form: form.firstObj, key: 'content' }">{{ form.firstObj.content }}</p>
                    </div>
                    <div class="number-show-content wow fadeInUp">
                        <div class="number-show-cell" v-for="(item, key) in form.firstObj.list" :key="key">
                            <div class="text-line text-overflow">
                                <div class="number text-overflow beatingNumber-box">
                                    <div class="beatingNumber" v-edit="{ form: item, key: 'name' }">{{ item.name }}</div>
                                    <span class="unit" v-edit="{ form: item, key: 'unit' }">{{ item.unit }}</span>
                                    <span class="add-icon" v-edit="{ form: item, key: 'type' }">{{ item.type }}</span>
                                </div>
                                <div class="line"></div>
                            </div>
                            <p class="number-name font22" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="in-show-box" :style="'background-image: url(' + require('../../assets/pingpai/brand_bg.jpg') + ')'">
                <div class="container1" @click.stop>
                    <div class="boxTitleTips wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</p>
                        <p class="tips font24" v-edit="{ form: form.secoundObj, key: 'content' }">{{ form.secoundObj.content }}</p>
                    </div>
                    <div class="in-show-content wow fadeInUp">
                        <div class="in-show">
                            <div class="in-show-one">
                                <p class="in-show-name font26" v-edit="{ form: form.secoundObj.obj1, key: 'title' }">{{ form.secoundObj.obj1.title }}</p>
                                <div class="in-show-tips">
                                    <!-- <img src="../../assets/fuwu/notice.png" />
									<span>今日新增&nbsp;103&nbsp;人提交小吃甜点品牌意向</span> -->
                                </div>
                                <div class="img-show-content font18">
                                    <div class="img-show-div" v-for="(item, key) in form.secoundObj.obj1.list" :key="key">
                                        <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                        <div class="img-name-box">
                                            <p class="name-text" v-edit="{ form: item, key: 'name' }">{{ item.name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="in-show-two">
                                <p class="name font26" v-edit="{ form: form.secoundObj.obj2, key: 'title' }">{{ form.secoundObj.obj2.title }}</p>
                                <div id="allBrand" class="tabs-head-box">
                                    <div class="tab-ul-name" v-for="(item, key) in form.secoundObj.obj2.list" :key="key">
                                        <itemAdd :list="form.secoundObj.obj2.list" :itemIndex="key"></itemAdd>
                                        <p
                                            class="tab-name font20"
                                            :class="{ 'tab-ul-name-active': carouselActive == key }"
                                            @mouseenter="tabPp(key)"
                                            v-edit="{ form: item, key: 'title' }"
                                        >
                                            {{ item.title }}
                                        </p>
                                    </div>
                                </div>
                                <el-carousel ref="remarkCaruselUp" indicator-position="none" arrow="never" @change="carouselChange">
                                    <el-carousel-item v-for="(item, key) in form.secoundObj.obj2.list" :key="key">
                                        <div class="carousel-img-content">
                                            <span v-for="(i, index) in item.list" :key="index">
                                                <itemAdd :list="item.list" :itemIndex="index"></itemAdd>
                                                <img v-img="{ form: item.list, key: index }" style="width:170px;height: 85px;" :src="i" />
                                            </span>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                        <div class="but join-but join-but-hover wow fadeInUp">
                            <div class="but-background"></div>
                            <p class="c-t font20" style="cursor:pointer" v-edit="{ form: form.secoundObj, key: 'bottomContent' }" @click="showToggle">{{ form.secoundObj.bottomContent }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="animateDom cooperation-box" v-img="{ form: form.thiredObj, key: 'img' }" :style="'background-image: url(' + form.thiredObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="cooperation-content">
                        <div class="cooperation-text cooperation-animate-module">
                            <p class="cooperation-text-title font36" v-edit="{ form: form.thiredObj, key: 'title' }">{{ form.thiredObj.title }}</p>
                            <p class="cooperation-text-tips font18" v-edit="{ form: form.thiredObj, key: 'content' }">{{ form.thiredObj.content }}</p>
                        </div>
                        <div class="contact-img">
                            <img src="../../assets/cloudHome/contact.png" />
                            <img v-img="{ form: form.thiredObj, key: 'contactCode' }" style="width:100px;height:100px" :src="form.thiredObj.contactCode" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="159" :id="134"></submit-form>
        <guidance :show="show" @hiddenToggle="hiddenToggle"></guidance>
    </div>
</template>

<script>
import navBar from '../../components/superiorStaffNavBar.vue';
import submitForm from '../../components/submit-form.vue';
import { WOW } from 'wowjs';
import { pageQuery } from '../../api/index';
import Guidance from '@/components/guidance.vue';
import itemAdd from '../../components/item-add.vue';
export default {
    name: '',
    data() {
        return {
            show: false,
            carouselActive: 0,
            form: {
                // bannerObj:{
                // 	img:require('../../assets/pingpai/banner_brand.jpg'),
                // 	title:'成为上上参谋入驻品牌',
                // 	content:'助力300万用户开好店'
                // },
                // firstObj:{
                // 	title:'海量开店用户聚集',
                // 	content:'百万用户的数字化开店平台',
                // 	list:[{
                // 		name:'300',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'开店者'
                // 	},{
                // 		name:'100',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'月活开店者'
                // 	},{
                // 		name:'50',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'待转商铺'
                // 	},
                // 	{
                // 		name:'1000',
                // 		unit:'',
                // 		type:'+',
                // 		content:'优选品牌加盟'
                // 	}]
                // },
                // secoundObj:{
                // 	title:'上上参谋已入驻服务商',
                // 	content:'文字描述文字描述文字描述文字描述文字描述',
                // 	img:require('../../assets/pingpai/brand_bg.jpg'),
                // 	bottomContent:'我是服务商，我要加入',
                // 	obj1:{
                // 		title:'热卖服务',
                // 		list:[{
                // 			name:'小吃甜点',
                // 			img:require('../../assets/pingpai/hot_1.png')
                // 		},{
                // 			name:'茶饮咖啡',
                // 			img:require('../../assets/pingpai/hot_2.png')
                // 		},{
                // 			name:'零售便利',
                // 			img:require('../../assets/pingpai/hot_3.png')
                // 		},{
                // 			name:'生活服务',
                // 			img:require('../../assets/pingpai/hot_4.png')
                // 		},{
                // 			name:'酒水',
                // 			img:require('../../assets/pingpai/hot_5.png')
                // 		}]
                // 	},
                // 	obj2:{
                // 		title:'全部品牌',
                // 		list:[{
                // 			title:'餐饮美食',
                // 			list:[require('../../assets/logo/logoicon (1).png'),require('../../assets/logo/logoicon (2).png'),require('../../assets/logo/logoicon (3).png'),require('../../assets/logo/logoicon (4).png'),require('../../assets/logo/logoicon (4).png'),require('../../assets/logo/logoicon (6).png'),require('../../assets/logo/logoicon (7).png'),require('../../assets/logo/logoicon (8).png'),require('../../assets/logo/logoicon (9).png'),]
                // 		},{
                // 			title:'连锁零售',
                // 			list:[require('../../assets/logo/logoicon (2).png'),require('../../assets/logo/logoicon (3).png'),require('../../assets/logo/logoicon (4).png'),require('../../assets/logo/logoicon (5).png'),require('../../assets/logo/logoicon (6).png'),require('../../assets/logo/logoicon (7).png'),require('../../assets/logo/logoicon (8).png'),require('../../assets/logo/logoicon (9).png'),require('../../assets/logo/logoicon (11).png'),require('../../assets/logo/logoicon (13).png'),require('../../assets/logo/logoicon (15).png'),]
                // 		},{
                // 			title:'生活服务',
                // 			list:[require('../../assets/logo/logoicon (3).png'),require('../../assets/logo/logoicon (4).png'),require('../../assets/logo/logoicon (6).png'),require('../../assets/logo/logoicon (8).png'),require('../../assets/logo/logoicon (10).png'),require('../../assets/logo/logoicon (12).png'),require('../../assets/logo/logoicon (14).png'),require('../../assets/logo/logoicon (16).png'),]
                // 		}]
                // 	}
                // },
                // thiredObj:{
                // 	img:require('../../assets/canmo/contact_blue_bg.jpg'),
                // 	title:'想要了解更多信息或寻求商务合作',
                // 	content:'您可以通过以下方式联系我们，我们将为您推荐满足需求的产品，或指派专业的销售顾问为您服务。'
                // }
            }
        };
    },
    mounted() {
        pageQuery({ componentId: '159', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                var oT = $(window).height() * 0.1;
                var t = 0.1,
                    e = !0,
                    wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: oT,
                        callback: function(e) {
                            (e = $(e)).css('animation-delay', t.toFixed(1) + 's'), (t += 0.1);
                        }
                    });
                $(window).scroll(function() {
                    e &&
                        ((t = 0.2),
                        setTimeout(function() {
                            e = !0;
                        }, 150),
                        (e = !1));
                }),
                    wow.init();
                $('.beatingNumber').each(function() {
                    var h = Number($(this).html());
                    var t = '';
                    var n = Math.ceil(h / 20);
                    var a = true;
                    var This = $(this);
                    if ($(this).length != 0) {
                        t = $(this).offset().top;
                    }
                    This.html(0);
                    fn1();
                    $(window).scroll(function() {
                        fn1();
                    });

                    function fn1() {
                        var wT = $(window).scrollTop();
                        if (wT > t - $(window).height() + 50 && wT < t - 50 && a == true) {
                            a = false;
                            var y = 0;
                            var timer2 = setInterval(function() {
                                if (y >= h) {
                                    y = h;
                                    clearInterval(timer2);
                                }
                                This.html(y);
                                y += n;
                            }, 100);
                        }
                    }
                });
            });
            setTimeout(() => {
                $('#allBrand .tab-ul-name').hover(
                    e => {
                        $('#allBrand .tab-ul-name')
                            .find('.tab-name')
                            .removeClass('tab-ul-name-active');
                        $(e.currentTarget)
                            .find('.tab-name')
                            .addClass('tab-ul-name-active');
                        $(e.currentTarget)
                            .find('.tab-ul')
                            .css({
                                display: 'flex'
                            });
                    },
                    e => {
                        $(e.currentTarget)
                            .find('.tab-ul')
                            .css({
                                display: 'none'
                            });
                    }
                );
            }, 500);
        });
    },
    computed: {},
    methods: {
        showToggle() {
            if (this.$store.state.token) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        carouselChange(index) {
            this.carouselActive = index;
        },
        // 轮播图切换至上一页
        prevClick(e) {
            this.$refs.carouselRef.prev();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        // 轮播图切换至下一页
        nextClick(e) {
            this.$refs.carouselRef.next();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        performFunction() {
            let idName = [];
            for (let i = 1; i < 5; i++) {
                idName.push('beatingNumber' + i);
            }
            idName.forEach(i => {
                this.numberBeating(i);
            });
        },
        numberBeating(targetIdName = 'beatingNumber') {
            let dom = $('#' + targetIdName);
            let height = dom.parent().height();
            let text = dom.attr('data-num');
            dom.css({
                height: height + 'px'
            });
            let num = text.replace(/[^0-9]/gi, ''); //提取数字
            let len = num.length;
            for (let i = 0; i < len; i++) {
                let html = `<div class='beatingNumber-cell'>`;
                for (let t = 0; t < 10; t++) {
                    html = html + `<p>${t}</p>`;
                }
                html = html + '</div>';
                dom.append(html);
            }
            setTimeout(() => {
                let childrenDom = dom.find('.beatingNumber-cell');
                let numArr = num.split('');
                numArr.forEach((i, index) => {
                    let el = childrenDom.eq(index);
                    let elHeight = el.find('p').height();
                    el.css({
                        transform: `translateY(-${elHeight * i}px)`
                    });
                });
            }, 500);
        },
        tabPp(index) {
            this.$refs.remarkCaruselUp.setActiveItem(index);
        }
    },
    components: { navBar, submitForm, Guidance, itemAdd }
};
</script>

<style scoped lang="less">
@media screen and (max-width: 1024px) {
    .brand-box {
        .head-box {
            height: auto !important;
            background-color: #fff;
        }

        .content {
            .banner-box {
                .text-content {
                    margin-left: 10px !important;
                }
            }

            .animateDom {
                .box-title {
                    padding: 0 10px;
                }

                .tips {
                    padding: 0 10px;
                }

                .button-box {
                    padding-left: 10px;
                }

                .tabs-title {
                    padding: 0 10px;
                }
            }

            .number-show-box {
                .number-show-content {
                    .number-show-cell {
                        .number {
                            padding: 0 !important;
                        }

                        .line {
                            display: none;
                        }
                    }
                }
            }

            .carousel-show-box {
                .carousel-show-content {
                    width: 100% !important;

                    ::v-deep {
                        .el-carousel {
                            width: 100% !important;

                            .el-carousel__container {
                                height: 760px !important;
                                overflow-y: auto;
                                overflow-x: hidden;
                            }

                            .carousel-content {
                                padding: 35px 20px !important;

                                .content-left {
                                    width: 100% !important;

                                    .textContent {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        align-items: center;
                                        padding: 0 20px 20px 22px !important;

                                        .logo-text {
                                            padding-right: 0 !important;
                                        }

                                        .number-show-div {
                                            width: 100% !important;
                                            flex-direction: column;

                                            .number-show-cell {
                                                width: 100% !important;

                                                .text-line {
                                                    justify-content: center !important;
                                                }
                                            }
                                        }

                                        .line {
                                            display: none;
                                        }
                                    }
                                }

                                .r-img {
                                    display: none;
                                }
                            }
                        }
                    }

                    .control-but {
                        width: 40px !important;
                        height: 40px !important;
                        z-index: 1000;
                    }

                    .button-left {
                        left: 0 !important;
                    }

                    .button-right {
                        right: 0 !important;
                    }
                }
            }

            .in-show-box {
                padding-top: 40px !important;

                .in-show-content {
                    .in-show {
                        width: 100% !important;

                        .in-show-two {
                            box-sizing: border-box;
                            overflow-x: auto;
                            overflow-y: hidden;

                            .tabs-head-box {
                                height: auto !important;
                            }

                            .el-carousel {
                                width: 100% !important;

                                .el-carousel__container {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .join-but {
                        padding: 20px 30px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1540px) {
    .brand-box {
        .content {
            .banner-box {
                .text-box {
                    justify-content: flex-start !important;
                }
            }

            .tab-show-box {
                .tab-show-content {
                    overflow-x: auto;
                    overflow-y: hidden;
                }
            }
        }
    }
}

@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.brand-box {
    width: 100%;
    position: relative;

    .but {
        background-color: #0081ff;
        padding: 16px 40px;
        font-size: 16px;
        border: none;
        border-radius: 35px;
    }

    .but-blank {
        background: none;
        border: thin solid #fff;
    }

    .join-but {
        border-radius: 6px;
        padding: 22px 140px;
        // font-size: 20px;
        margin: 70px 0 130px 0;
        position: relative;
        background: #0081ff;
        @media @max-sm {
            padding: 22px 50px;
            margin: 60px 0;
        }
        .but-background {
            width: 0%;
            height: 100%;
            background-color: #0269cf;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transition: all 0.5s;
            border-radius: 6px;
        }

        .c-t {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            color: #fff;
        }
    }

    .join-but-hover:hover {
        .but-background {
            width: 100%;
        }
    }

    .m-b {
        background-color: #eb5405;
        margin: 40px 0 0 0;
    }

    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(255, 255, 255, 1);
    }

    .content {
        width: 100%;

        .banner-box {
            width: 100%;
            height: 600px;
            box-sizing: border-box;
            padding: 155px 0 0 0;
            // background: url('../../assets/pingpai/banner_brand.jpg') no-repeat;
            background-size: cover;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            @media @max-xs {
                height: 80vw;
            }
            .text-content {
                // max-width: 550px;
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // margin-left: 65px;

                .tip-text {
                    margin-bottom: 80px;
                }
            }
        }

        .number-show-box {
            width: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 110px 0 100px 0;
            @media @max-xs {
                padding: 60px 0;
            }
            .box-title {
                color: #000;
                // font-size: 40px;
                margin-bottom: 15px;
                text-align: center;
            }

            .tips {
                text-align: center;
                color: #333;
                // font-size: 24px;
                margin-bottom: 35px;
                @media @max-xs {
                    margin-bottom: 0;
                }
            }

            .number-show-content {
                display: flex;
                flex-wrap: wrap;
                // justify-content: center;
                // align-items: center;

                .number-show-cell {
                    width: 25%;
                    box-sizing: border-box;
                    background: url('../../assets/fuwu/num_bg.png') no-repeat;
                    background-size: 237px 168px;
                    background-position: 55px center;
                    @media @max-md {
                        width: 50%;
                        margin-top: 40px;
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                        height: 100%;
                        background-color: #9acfff;
                    }
                    &:nth-child(even) {
                        &::before {
                            display: none;
                        }
                    }
                    &:last-child {
                        &::before {
                            display: none;
                        }
                    }

                    .text-line {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .number {
                            width: 100%;
                            // height: 120px;
                            box-sizing: border-box;
                            box-sizing: border-box;
                            font-size: 80px;
                            line-height: 112px;
                            text-align: center;
                            // padding: 0 60px;
                            color: #0081ff;
                            font-family: 'PingFang-Heavy';
                            @media @max-lg {
                                font-size: 60px;
                                line-height: 80px;
                            }
                            @media @max-md {
                                font-size: 50px;
                                line-height: 70px;
                            }
                            @media @max-xs {
                                font-size: 35px;
                                line-height: 50px;
                            }
                            .unit {
                                font-size: 70px !important;
                                transform: translateY(4px);
                                @media @max-lg {
                                    font-size: 50px !important;
                                }
                                @media @max-md {
                                    font-size: 40px !important;
                                }
                                @media @max-xs {
                                    transform: translateY(0px);
                                    font-size: 30px !important;
                                }
                            }

                            .add-icon {
                                font-size: 55px;
                                @media @max-sm {
                                    font-size: 24px;
                                }
                            }
                        }
                    }

                    .number-name {
                        width: 100%;
                        text-align: center;
                        // font-size: 22px;
                        color: #999999;
                    }
                }
            }
        }

        .carousel-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #f7f9fa;
            background-image: url('../../assets/fuwu/case_icon_bg.png');
            background-repeat: no-repeat;
            background-size: 625px 505px;
            background-position: left top;
            padding-top: 120px;

            .box-title {
                color: #000;
                font-size: 40px;
                margin-bottom: 4px;
            }

            .tips {
                color: #5a6779;
                font-size: 24px;
                margin-bottom: 55px;
            }

            .carousel-show-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-bottom: 115px;
                position: relative;

                ::v-deep {
                    .el-carousel {
                        width: 1300px;

                        .el-carousel__container {
                            height: 600px;
                            border-radius: 8px;
                            background: none;
                        }
                    }
                }

                .control-but {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: calc(50% - 86px);
                }

                .control-but-active {
                    background-color: #eb5405;
                    color: #fff !important;
                    border: none;
                }

                .button-left {
                    left: -100px;
                }
                .button-right {
                    right: -100px;
                }

                .carousel-content {
                    width: 100%;
                    height: 100%;
                    padding: 35px 0px;
                    border-radius: 8px;
                    box-sizing: border-box;

                    .carousel-item-box {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .content-left {
                            width: calc(100% - 520px);
                            height: 100%;

                            .head-tabs {
                                width: 100%;
                                height: 60px;
                                display: flex;
                                align-items: flex-start;
                                overflow-x: auto;
                                overflow-y: hidden;

                                .carousel-tab {
                                    width: 130px;
                                    box-sizing: border-box;
                                    padding-right: 5px;
                                    font-size: 24px;
                                    color: #999999;
                                }

                                .tab-active {
                                    color: #121826 !important;
                                }
                            }

                            .textContent {
                                height: calc(100% - 70px);
                                box-sizing: border-box;
                                background-color: #fff;
                                padding: 0 0 20px 40px;
                                border-radius: 8px 0 0 8px;

                                .logo-text {
                                    height: 136px;
                                    box-sizing: border-box;
                                    padding: 50px 50px 32px 0;
                                    display: flex;
                                    flex-wrap: wrap;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    border-bottom: thin solid #f4f7fa;
                                    background: url('../../assets/fuwu/case_icon_s_bg.png') no-repeat;
                                    background-size: 390px 183px;
                                    background-position: 600px top;

                                    .logoText {
                                        display: flex;
                                        align-items: center;

                                        .logoImg {
                                            width: 88px;
                                            height: 65px;
                                            object-fit: scale-down;
                                        }

                                        .logoName {
                                            font-size: 24px;
                                            color: #333333;
                                            margin-left: 10px;
                                        }
                                    }

                                    .text {
                                        width: 210px;
                                        font-size: 14px;
                                        color: #666666;
                                        letter-spacing: 0;
                                    }
                                }

                                .number-show-div {
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-items: center;
                                    margin-top: 50px;

                                    .number-show-cell {
                                        width: 160px;
                                        box-sizing: border-box;
                                        color: #fff;

                                        .text-line {
                                            width: 100%;
                                            display: flex;
                                            justify-content: flex-start;
                                            align-items: baseline;
                                            color: #0081ff;
                                            font-size: 30px;
                                            font-family: 'PingFang-Heavy' !important;

                                            .number {
                                                box-sizing: border-box;
                                                font-size: 55px;
                                                text-align: center;
                                            }
                                        }

                                        .number-name {
                                            width: 100%;
                                            text-align: center;
                                            font-size: 16px;
                                            color: #999999;
                                            transform: translateY(-14px);
                                        }
                                    }

                                    .line {
                                        width: 2px;
                                        height: 40px;
                                        background-color: #e6e6e6;
                                        margin-right: 28px;
                                    }
                                }

                                .but {
                                    margin-top: 29px;
                                }
                            }
                        }

                        .r-img {
                            height: 100%;

                            img {
                                width: 520px;
                                height: 520px;
                            }
                        }
                    }
                }
            }
        }

        .in-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            // background-image: url('../../assets/pingpai/brand_bg.jpg');
            background-repeat: no-repeat;
            background-size: 100% 300px;
            padding-top: 80px;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;

            .box-title {
                color: #fff;
                margin-bottom: 15px;
            }

            .tips {
                color: #fff;
                margin-bottom: 55px;
            }

            .in-show-content {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .in-show {
                    background-color: #fff;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 0px 14px 0 rgba(204, 204, 204, 0.35);

                    .in-show-one {
                        width: 100%;
                        box-sizing: border-box;
                        padding: 52px 40px 55px 50px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: space-between;
                        @media @max-xs {
                            padding: 30px;
                        }
                        .in-show-name {
                            color: #333333;
                        }

                        .in-show-tips {
                            font-size: 14px;
                            color: #65697f;
                            display: flex;
                            align-items: center;
                            margin-bottom: 32px;

                            img {
                                width: 17px;
                                height: 17px;
                                margin-right: 9px;
                            }
                        }

                        .img-show-content {
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            margin-bottom: -20px;
                            // overflow-x: auto;
                            // overflow-y: hidden;

                            .img-show-div {
                                width: calc(20% - 17px);
                                height: 326px;
                                border-radius: 8px;
                                position: relative;
                                overflow: hidden;
                                transition: width 0.8s;
                                margin-right: 20px;
                                margin-bottom: 20px;
                                @media @max-lg {
                                    height: 280px;
                                }
                                @media @max-md {
                                    height: 250px;
                                }
                                @media @max-sm {
                                    height: 200px;
                                }
                                @media @max-xs {
                                    width: calc(50% - 10px);
                                    height: 200px;
                                }
                                img {
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 8px;
                                    object-fit: cover;
                                    transition: transform 0.8s;
                                }

                                .img-name-box {
                                    width: 100%;
                                    box-sizing: border-box;
                                    background-color: rgba(0, 0, 0, 0);
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translateX(-50%) translateY(-50%);
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;

                                    .name-text {
                                        color: #fff;
                                    }
                                }
                            }

                            .img-show-div:nth-child(5n) {
                                margin-right: 0;
                                @media @max-xs {
                                    margin-right: 17px;
                                }
                            }
                            .img-show-div:nth-child(2n) {
                                @media @max-xs {
                                    margin-right: 0;
                                }
                            }

                            .img-show-div:hover img {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }

                    .in-show-two {
                        width: 100%;
                        box-sizing: border-box;
                        padding: 52px 3px 65px 50px;
                        @media @max-xs {
                            padding: 30px;
                        }
                        .name {
                            margin-top: -50px;
                            color: #333;
                            margin-bottom: 20px;
                            @media @max-xs {
                                margin-top: -20px;
                            }
                        }

                        .tabs-head-box {
                            width: calc(100% - 50px);
                            height: 73px;
                            padding-right: 50px;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            background-color: #f7f9fa;
                            @media @max-md {
                                padding-right: 0;
                            }
                            @media @max-xs {
                                width: 100%;
                            }
                            .tab-ul-name {
                                border-radius: 6px 6px 0 0;
                                position: relative;
                                @media @max-xs {
                                    width: 100%;
                                }
                                .tab-name {
                                    width: 196px;
                                    height: 73px;
                                    border-radius: 6px 6px 0 0;
                                    box-sizing: border-box;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    color: #65697f;
                                    padding: 0 20px 0 20px;
                                    // @media @max-sm {
                                    // 	width: 175px;
                                    // }
                                    @media @max-xs {
                                        width: 100%;
                                        height: 50px;
                                    }
                                }

                                .tab-ul {
                                    width: 196px;
                                    box-sizing: border-box;
                                    display: none;
                                    // display: flex;
                                    flex-wrap: wrap;
                                    align-items: center;
                                    align-content: flex-start;
                                    background-color: #0081ff;
                                    padding: 0 20px 0 20px;
                                    border-radius: 0 0 6px 6px;
                                    position: absolute;
                                    top: 72px;
                                    left: 0;
                                    z-index: 100000;
                                    padding-top: 10px;
                                    // @media @max-sm {
                                    // 	width: 175px;
                                    // }
                                    @media @max-xs {
                                        width: 100%;
                                        top: 50px;
                                    }
                                    li {
                                        box-sizing: border-box;
                                        padding: 2px 10px;
                                        font-size: 14px;
                                        color: #fff;
                                        margin: 0px 0 6px 0;
                                        border-radius: 4px;
                                    }

                                    .active-li {
                                        border: thin solid #fff;
                                    }
                                }
                            }

                            .tab-ul-name-active {
                                background-color: #0081ff;
                                color: #fff !important;
                            }

                            // .tab-ul-name:hover {
                            // 	background-color: #0081ff;
                            // }

                            // .tab-ul-name:hover .tab-name {
                            // 	color: #fff !important;
                            // }

                            // .tab-ul-name:hover .tab-ul {
                            // 	display: flex;
                            // }
                        }

                        ::v-deep {
                            .el-carousel {
                                width: 100%;
                                padding: 0 20px;
                                margin: 0 -20px;
                                @media @max-xs {
                                    width: auto !important;
                                }
                                .el-carousel__container {
                                    width: 100%;
                                    border-radius: 8px;
                                    background: none;
                                    height: auto;
                                    min-height: 300px;
                                    .el-carousel__item {
                                        height: 100%;
                                    }
                                }

                                .el-carousel__indicators {
                                    text-align: left;
                                    text-indent: 2em;

                                    .is-active {
                                        button {
                                            width: 40px;
                                            background-color: #0081ff;
                                        }
                                    }
                                }
                            }
                        }

                        .carousel-img-content {
                            padding: 10px 0 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            align-content: flex-start;
                            // overflow-y: auto;
                            // overflow-x: hidden;
                            img {
                                width: calc(14.28% - 20px);
                                height: 75px;
                                object-fit: scale-down;
                                box-shadow: 0 0px 14px 0 rgba(142, 173, 255, 0.13);
                                margin: 20px 20px 0 0;
                                @media @max-md {
                                    height: 50px;
                                }
                                @media @max-sm {
                                    height: 50px;
                                    width: calc(25% - 20px);
                                }
                                @media @max-xs {
                                    height: 50px;
                                    width: calc(50% - 10px);
                                    &:nth-child(2n) {
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .cooperation-box {
            width: 100%;
            height: auto;
            // background: url('../../assets/fuwu/provider_bg.jpg') no-repeat;
            background-repeat: no-repeat;
            background-size: cover;
            padding-top: 28px;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;
            @media @max-sm {
                padding-top: 60px;
            }
            .cooperation-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                align-content: flex-start;

                .cooperation-text {
                    max-width: 550px;
                    color: #fff;
                    padding-left: 10px;
                    letter-spacing: 0;
                    @media @max-md {
                        max-width: 450px;
                    }
                    @media @max-sm {
                        max-width: 100%;
                        width: 100%;
                        text-align: center;
                        padding-left: 0;
                    }
                    .cooperation-text-title {
                        // font-size: 35px;
                        margin-bottom: 4px;
                        font-family: 'PingFang-Heavy' !important;
                        // transform: translateY(-14px);
                    }
                }

                .contact-img {
                    position: relative;
                    margin-right: 120px;

                    @media @max-md {
                        margin-right: 60px;
                    }
                    @media @max-sm {
                        margin-top: 60px;
                        margin-right: 0;
                        margin: 60px auto 0;
                    }
                    img {
                        width: 260px;
                        height: auto;
                        object-fit: scale-down;
                        &:nth-child(2) {
                            position: absolute;
                            left: 82px;
                            width: 100px;
                            top: 84px;
                        }
                    }
                }
            }
        }
    }
}
</style>
